/* pbk-drag-scroll.js
   PC ブラウザ（マウス）で横スクロール領域をドラッグしてスクロールできるようにする。
   トップの新着一覧・PDP の Similar/SameColor/Recently レール・カートおすすめレール・
   SP 幅時の PDP メインスライダー等、overflow-x:auto|scroll で実際に横はみ出しがある要素を
   マウス pointerdown 時に自動検出する（data 属性やクラス列挙は不要）。
   - マウス(pointerType==='mouse') かつ主ボタンのみ。タッチのネイティブスワイプは触らない。
   - ドラッグ距離 > 5px でドラッグ確定 → 直後の click を 1 回だけ抑止（カードの誤遷移防止）。
   - 横はみ出しが無い（PC 幅でグリッド化した）状態では no-op。 */
(function () {
  'use strict';

  var THRESHOLD = 5;

  function isScrollableX(el) {
    if (!(el instanceof Element)) return false;
    if (el.scrollWidth - el.clientWidth <= 1) return false;
    var ox = window.getComputedStyle(el).overflowX;
    return ox === 'auto' || ox === 'scroll';
  }

  /* pointerdown 起点から一番近い「横スクロール可能」祖先を探す */
  function findRail(start) {
    var el = start;
    while (el && el !== document.body && el !== document.documentElement) {
      if (isScrollableX(el)) return el;
      el = el.parentElement;
    }
    return null;
  }

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    /* フォーム部品上のドラッグは横取りしない */
    if (e.target.closest && e.target.closest('input, textarea, select, [contenteditable=""], [contenteditable="true"]')) return;

    var rail = findRail(e.target);
    if (!rail) return;

    var startX = e.clientX;
    var startScroll = rail.scrollLeft;
    var pointerId = e.pointerId;
    var moved = false;
    var savedSnap = '';

    function onMove(ev) {
      var dx = ev.clientX - startX;
      if (!moved) {
        if (Math.abs(dx) <= THRESHOLD) return;
        moved = true;
        rail.style.cursor = 'grabbing';
        rail.style.userSelect = 'none';
        savedSnap = rail.style.scrollSnapType;
        rail.style.scrollSnapType = 'none'; /* ドラッグ中はスナップの引っ張り合いを止める */
        try { rail.setPointerCapture(pointerId); } catch (err) {}
      }
      rail.scrollLeft = startScroll - dx;
      if (ev.cancelable) ev.preventDefault();
    }

    function onUp() {
      rail.removeEventListener('pointermove', onMove);
      rail.removeEventListener('pointerup', onUp);
      rail.removeEventListener('pointercancel', onUp);
      try { rail.releasePointerCapture(pointerId); } catch (err) {}
      if (!moved) return;
      rail.style.cursor = '';
      rail.style.userSelect = '';
      rail.style.scrollSnapType = savedSnap;
      /* ドラッグ直後の click（カードリンク等）を 1 回だけ握りつぶす */
      var suppress = function (clickEv) {
        clickEv.stopPropagation();
        clickEv.preventDefault();
        document.removeEventListener('click', suppress, true);
      };
      document.addEventListener('click', suppress, true);
      setTimeout(function () { document.removeEventListener('click', suppress, true); }, 0);
    }

    rail.addEventListener('pointermove', onMove);
    rail.addEventListener('pointerup', onUp);
    rail.addEventListener('pointercancel', onUp);
  });
})();
